<div class="modal-overlay" *ngIf="isOpen" [class.closing]="isClosing" (click)="onDocumentClick($event)">
  <div class="modal-content" [class.closing]="isClosing">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Schedule Shift</h2>
        <button class="close-button" (click)="onClose()" [disabled]="isSaving" [attr.aria-disabled]="isSaving">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M1 11L11 1" stroke="#555963" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Employees Section -->
      <div class="form-section">
        <label class="form-label">Employees</label>
        <div class="dropdown-container">
          <div class="dropdown-input" [class.active]="showEmployeesDropdown" (click)="toggleEmployeesDropdown()">
            <div class="input-content">
              <span class="input-text" [class.placeholder]="scheduleData.employees.length === 0">{{ getSelectedEmployeesText() }}</span>
            </div>
            <svg class="chevron-down" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 3.6L7 10.4L13 3.6" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          
          <!-- Employees Dropdown -->
          <div class="dropdown-menu employees-dropdown" *ngIf="showEmployeesDropdown">
            <div class="dropdown-header">
              <h3>Select Employees</h3>
            </div>
            
            <!-- Select All Option -->
            <div class="dropdown-option select-all-option" (click)="toggleSelectAll(); $event.stopPropagation()">
              <div class="checkbox-container">
                <input 
                  type="checkbox" 
                  [checked]="isAllSelected()"
                  (click)="$event.stopPropagation()"
                  (change)="toggleSelectAll()"
                  class="checkbox-input"
                >
                <div class="checkbox-custom" [ngClass]="{ 'checked': isAllSelected() }">
                  <svg *ngIf="isAllSelected()" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6L5 9L10 3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <div class="employee-avatar-spacer"></div>
              <span class="option-text">Select all</span>
            </div>
            
            <!-- Employee List -->
            <div class="employee-list">
              <div *ngIf="loadingEmployees" class="loading-indicator">
                Loading employees...
              </div>
              <div 
                class="dropdown-option employee-option" 
                *ngFor="let employee of getFilteredEmployees(); trackBy: trackByIndex"
                (click)="toggleEmployeeSelection(employee); $event.stopPropagation()"
              >
                <div class="checkbox-container">
                  <input 
                    type="checkbox" 
                    [checked]="isEmployeeSelected(employee.id)"
                    (click)="$event.stopPropagation()"
                    (change)="toggleEmployeeSelection(employee)"
                    class="checkbox-input"
                  >
                  <div class="checkbox-custom" [ngClass]="{ 'checked': isEmployeeSelected(employee.id) }">
                    <svg *ngIf="isEmployeeSelected(employee.id)" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6L5 9L10 3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                <div class="employee-avatar">
                  <img *ngIf="employee.picture_url" [src]="employee.picture_url" [alt]="employee.first_name + ' ' + employee.last_name" class="avatar-image">
                  <div *ngIf="!employee.picture_url" class="avatar-placeholder">
                    {{ getEmployeeInitials(employee) }}
                  </div>
                </div>
                <span class="option-text">{{ employee.first_name }} {{ employee.last_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Shift Section -->
      <div class="form-section">
        <label class="form-label">Shift</label>
        <div class="dropdown-container">
          <div class="dropdown-input" [class.active]="showShiftDropdown" (click)="toggleShiftDropdown()">
            <div class="input-content">
              <span class="input-text" [class.placeholder]="!scheduleData.shift">{{ getSelectedShiftText() }}</span>
            </div>
            <svg class="chevron-down" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 3.6L7 10.4L13 3.6" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          
          <!-- Shift Dropdown -->
          <div class="dropdown-menu" *ngIf="showShiftDropdown">
            <div class="dropdown-options">
              <div *ngIf="loadingShifts" class="loading-indicator">
                Loading shifts...
              </div>
              <div 
                class="dropdown-option" 
                *ngFor="let shift of availableShifts; trackBy: trackByIndex"
                (click)="selectShift(shift); $event.stopPropagation()"
              >
                <span>{{ shift.shift_name }}</span>
                <svg *ngIf="scheduleData.shift === shift.id" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#6366F1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Week Section -->
      <div class="form-section">
        <label class="form-label">Week</label>
        <div class="week-container">
          <div class="week-input" (click)="toggleWeekCalendar(); $event.stopPropagation()">
            <span class="week-text">{{ weekRange }}</span>
            <img src="assets/images/employee-icons/calender.svg" alt="Calendar" class="calendar-icon" width="15" height="14">
          </div>
          
          <!-- Week Navigation Buttons -->
          <div class="week-navigation">
            <button class="nav-arrow-button prev" (click)="navigateWeek('prev'); $event.stopPropagation()" title="Previous week">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M10.4 1L3.6 7L10.4 13" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="nav-arrow-button next" (click)="navigateWeek('next'); $event.stopPropagation()" title="Next week">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3.6 1L10.4 7L3.6 13" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          
          <!-- Week Calendar Dropdown -->
          <div class="week-calendar-dropdown" *ngIf="showWeekCalendar" 
               [style.top]="calendarPosition.top" 
               [style.left]="calendarPosition.left"
               [style.width]="calendarPosition.width"
               [class.open-upwards]="calendarPosition.openUpwards"
               (click)="$event.stopPropagation()">
            <div class="calendar-header">
              <button class="calendar-nav-button" (click)="navigateMonth('prev'); $event.stopPropagation()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M10.4 1L3.6 7L10.4 13" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <span class="month-year">{{ getCurrentMonthYear() }}</span>
              <button class="calendar-nav-button" (click)="navigateMonth('next'); $event.stopPropagation()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M3.6 1L10.4 7L3.6 13" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            
            <div class="calendar-grid">
              <div class="day-header" *ngFor="let day of dayHeaders; trackBy: trackByIndex">{{ day }}</div>
              <div 
                class="calendar-day" 
                *ngFor="let day of getCalendarDays(); trackBy: trackByIndex"
                [class.other-month]="day.isOtherMonth"
                [class.selected-week]="isDayInSelectedWeek(day.date)"
                [class.today]="isToday(day.date)"
                (click)="selectWeek(day.date); $event.stopPropagation()"
              >
                {{ day.day }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="footer-content">
        <button class="btn btn-secondary" (click)="onClose()" [disabled]="isSaving">
          <span>Cancel</span>
        </button>
        <button class="btn btn-primary" (click)="onSave()" [disabled]="!isFormValid || isSaving">
          <span *ngIf="!isSaving">Save</span>
          <span *ngIf="isSaving" class="saving-content">
            <svg class="spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="43.98" stroke-dashoffset="10.99" opacity="0.3"/>
              <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="43.98" stroke-dashoffset="10.99" class="spinner-circle"/>
            </svg>
            <span>Saving...</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
